import { loadStripe } from '@stripe/stripe-js';


const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_key_here';

if (!publishableKey || publishableKey === 'pk_test_your_key_here') {
  console.error('Stripe publishable key is not set! Please add REACT_APP_STRIPE_PUBLISHABLE_KEY to your .env file');
}

const stripePromise = loadStripe(publishableKey);

export default stripePromise; 